export default "__VITE_PUBLIC_ASSET__859b8200__"